import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import { useState } from 'react';
import Modal from '../../helpers/Modal';
export const UpdateQuoteForm = ({ quote, setQuotes }) => {
    const { token, base_url } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [freightAmount, setFreightAmount] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const openModal = () => {
        setFreightAmount('');
        setError('');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const amount = parseFloat(freightAmount);
        if (isNaN(amount) || amount < 0) {
            setError('Please enter a valid freight amount (0 or greater).');
            return;
        }

        setIsSubmitting(true);
        try {
            const updated = await updateData(token, `${base_url}/apis/billing/${quote.id}`, {
                freight_amount: amount,
            });

            if (updated?.quote) {
                setQuotes(prevQuotes =>
                    prevQuotes.map(q => q.id === quote.id ? updated.quote : q)
                );
            }

            window.showAlert?.(200, 'Freight amount updated successfully.');
            closeModal();
        } catch (err) {
            console.error('Error updating freight amount:', err);
            const status = err?.status ?? 500;
            if (status === 404) {
                window.showAlert?.(404, 'Quote not found.');
            } else if (status >= 400 && status < 500) {
                setError('Invalid request. Please check the freight amount and try again.');
            } else {
                window.showAlert?.(500, 'Failed to update freight amount. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const formContent = (
        <div>
            <h2>Update Freight Amount</h2>
            <p>Quote: <strong>{quote.quote_number}</strong></p>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor={`freight-amount-${quote.id}`}>Freight Amount ($)</label>
                    <input
                        id={`freight-amount-${quote.id}`}
                        type="number"
                        className="form-control"
                        min="0"
                        step="0.01"
                        value={freightAmount}
                        onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === '') {
                                setFreightAmount('');
                                return;
                            }
                            const value = parseFloat(raw);
                            setFreightAmount(isNaN(value) ? '' : String(Math.max(0, value)));
                        }}
                        placeholder="0.00"
                        disabled={isSubmitting}
                        autoFocus
                    />
                </div>
                {error && <p className="form-error">{error}</p>}
                <div className="form-actions">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="btn btn-secondary"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Updating…' : 'Update Freight'}
                    </button>
                </div>
            </form>
        </div>
    );

    return (
        <>
            <button
                type="button"
                className="btn btn-action btn-secondary"
                title="Update freight amount"
                onClick={openModal}
            >
                Update Freight
            </button>
            {isModalOpen && (
                <Modal form={formContent} setIsModalOpen={setIsModalOpen} />
            )}
        </>
    );
};
